import React from 'react';
import { HeadRow, useDayPicker } from 'react-day-picker-v8';
export function CustomHead() {
    const { classNames, styles, components } = useDayPicker();
    const HeadRowComponent = components?.HeadRow ?? HeadRow;
    return (React.createElement("thead", { style: styles.head, className: classNames.head, "aria-hidden": true },
        React.createElement(HeadRowComponent, null)));
}
//# sourceMappingURL=CustomHead.js.map